import { useGraphqlDelete } from "@mzara/component";

export const useMindMapInvitationDeleteMutation = () => {
    return useGraphqlDelete('mindMapInvitation');
};
